module.exports = __webpack_public_path__ + "static/media/vegitables_26.1231573b.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_26.csv
// module id = 609
// module chunks = 0